import { useEffect, useState } from "react";
import { Button, Modal, Radio, notification } from "antd";
import type { RadioChangeEvent } from "antd/lib/radio";
import { useFreire } from "../../utils/freireContext";
import {
  SHARE_STATION_TITLE,
  CLOSE,
  COPY_SHARE_LINK,
  ALL_RIGHT,
  SHARE_LINK_COPIED,
  SHARE_STATION_NO_EMSP,
} from "../../pages/Stations/locales";
import { useWhitelabels } from "../WhitelabelThemesProvider";
import "../ShareStation/index.css";
import copy from "copy-to-clipboard";

const normalize = (s: string) => s.replace(/[-_]/g, "");

type ShareEmspStationProps = {
  visible: boolean;
  stationID: string;
  onClose: () => void;
};

const ShareEmspStation = ({ visible, stationID, onClose }: ShareEmspStationProps) => {
  const { freire } = useFreire();
  const { emspWhiteLabels, allWhitelabels, getEmspStationLink } = useWhitelabels();
  const [selectedAlias, setSelectedAlias] = useState<string | undefined>();

  const onChange = (e: RadioChangeEvent) => setSelectedAlias(e.target.value);

  const onSubmit = () => {
    if (!selectedAlias) return;
    const link = getEmspStationLink(selectedAlias, stationID);
    if (!link) {
      notification.error({ message: freire(SHARE_STATION_NO_EMSP) });
      return;
    }
    copy(link);
    notification.success({
      message: freire(ALL_RIGHT),
      description: freire(SHARE_LINK_COPIED),
    });
    onClose();
  };

  useEffect(() => {
    setSelectedAlias(undefined);
  }, [visible]);

  return (
    <Modal
      title={freire(SHARE_STATION_TITLE)}
      visible={visible}
      width="30%"
      destroyOnClose
      centered
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>
          {freire(CLOSE)}
        </Button>,
        <Button
          key="submit"
          type="primary"
          disabled={!selectedAlias}
          onClick={onSubmit}
        >
          {freire(COPY_SHARE_LINK)}
        </Button>,
      ]}
    >
      {emspWhiteLabels.length === 0 ? (
        <p className="ShareStationEmptyMessage">{freire(SHARE_STATION_NO_EMSP)}</p>
      ) : (
        <Radio.Group
          className="ShareStationRadioContainer"
          value={selectedAlias}
          onChange={onChange}
        >
          {emspWhiteLabels.map((emspWl) => {
            const wl =
              allWhitelabels[emspWl.app_alias] ??
              Object.values(allWhitelabels).find(
                (w) => normalize(w.alias) === normalize(emspWl.app_alias)
              );
            return (
              <Radio key={emspWl.app_alias} value={emspWl.app_alias}>
                {wl?.name ?? emspWl.app_alias}
              </Radio>
            );
          })}
        </Radio.Group>
      )}
    </Modal>
  );
};

export default ShareEmspStation;
